var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',{staticClass:"mainContent homeContent"},[_c('router-link',{staticClass:"btn btn--primary",attrs:{"to":{ name: 'About' },"tag":"button"}},[_vm._v(" Start! ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }